var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.311 15.274a4.875 4.875 0 100-9.75 4.875 4.875 0 000 9.75z",
    stroke: "#6A737D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.63 5.705a4.876 4.876 0 111.324 9.569M1.56 18.78a8.252 8.252 0 0113.501 0M15.954 15.274a8.242 8.242 0 016.75 3.505",
    stroke: "#6A737D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconMembers;